import apiClient from '../../../shared/api/client';

export const getPacienteInformeById = async (pacienteId) => {
  const { data } = await apiClient.get(`/pacientes/informes/${pacienteId}`);
  return data;
};

export const getMedidaById = async (medidaId) => {
  const { data } = await apiClient.get(`/medidas/${medidaId}`);
  return data;
};

export const getMedidas = async () => {
  const { data } = await apiClient.get('/medidas');
  return data;
};

export const createMedida = async ({ idPaciente, userId, payload }) => {
  const { data } = await apiClient.post(`/medidas/${idPaciente}/${userId}`, payload);
  return data;
};

export const updateMedida = async ({ codigoInforme, payload }) => {
  const { data } = await apiClient.put(`/medidas/${codigoInforme}`, payload);
  return data;
};

export const deleteMedida = async (codigoInforme) => {
  const { data } = await apiClient.delete(`/medidas/${codigoInforme}`);
  return data;
};
